import { CreatorPost } from 'lib/types';
import {
  Chip,
} from '@mui/material';
import { uniqBy } from 'lodash';
import Link from 'next/link';
import { imagePostUrl } from 'lib/utils/imageUtils';
import { buildPostPath } from 'lib/helpers';

interface Props {
  posts: CreatorPost[];
  size?: number;
}

const POST_SIZE = 160;

export const CreatorPosts = ({
  posts, size = POST_SIZE,
}: Props) => {
  const imgBgUrl = (post: CreatorPost) => `${imagePostUrl(post.thumbnailUrl, {
    width: size + 20,
    height: size,
  })}`;

  if (!posts?.length) {
    return <div />;
  }

  const topPosts = posts.filter((p) => !!p.thumbnailUrl);
  const uniquePosts = uniqBy(topPosts, 'id');

  return (
    <div className="grid grid-cols-3 gap-4">
      {uniquePosts.slice(0, 3).map((p: CreatorPost) => (
        <div key={p.id} className="col-span-1 relative overflow-hidden">
          <Link href={{ pathname: '/posts/[postId]' }} as={buildPostPath(p)} passHref>

            {p.roleName && (
              <div className="absolute top-2 left-2 hidden sm:block">
                <Chip
                  sx={{ maxWidth: 120 }}
                  label={p.roleName}
                  size="small"
                  color="info"
                />
              </div>
            )}
            <img
              loading="lazy"
              className="rounded-xl border border-lightgray"
              src={imgBgUrl(p)}
              alt={p.caption}
              width={size}
              height={size}
            />

          </Link>
        </div>
      ))}
    </div>
  );
};
